import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common";
import { api, formatApiError } from "@/lib/api";

export const V3SettingsSection = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/settings/v3").then((r) => setF({ ...r.data, days: r.data.contract_alert_days.join(", "), tasks: r.data.maintenance_tasks.join("\n") })); }, []);
  if (!f) return null;
  const n = (k) => (e) => setF({ ...f, [k]: Number(e.target.value) });
  const save = async () => {
    try {
      const body = { ...f, contract_alert_days: f.days.split(/[,; ]+/).map(Number).filter((x) => x > 0), maintenance_tasks: f.tasks.split("\n") };
      const { data } = await api.put("/settings/v3", body);
      setF({ ...data, days: data.contract_alert_days.join(", "), tasks: data.maintenance_tasks.join("\n") });
      toast.success("Réglages enregistrés");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <section className="space-y-4 rounded-xl border border-cyan-400/15 bg-[#122549]/60 p-5" data-testid="v3-settings">
      <h2 className="text-base font-semibold text-white">Contrats, maintenance et règlements</h2>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Alertes avant échéance d'un contrat (jours)"><Input value={f.days} onChange={(e) => setF({ ...f, days: e.target.value })} data-testid="v3-alert-days-input" /></Field>
        <Field label="Alerte crédit d'heures faible (% restant)"><Input type="number" min={0} max={100} value={f.low_credit_percent} onChange={n("low_credit_percent")} data-testid="v3-low-credit-input" /></Field>
        <Field label="Factures sans échéance : vérifier après (jours)"><Input type="number" min={1} value={f.payment_check_days} onChange={n("payment_check_days")} data-testid="v3-payment-days-input" /></Field>
        <Field label="Atelier : alerte si matériel prêt non récupéré après (jours)"><Input type="number" min={1} max={90} value={f.workshop_ready_days ?? 7} onChange={n("workshop_ready_days")} data-testid="v3-workshop-days-input" /></Field>
        <Field label="Préventif : prévenir combien de jours avant"><Input type="number" min={0} value={f.preventive_horizon_days} onChange={n("preventive_horizon_days")} data-testid="v3-horizon-input" /></Field>
        <Field label="Modèle de tâches de maintenance (une par ligne)" className="sm:col-span-2">
          <Textarea rows={8} value={f.tasks} onChange={(e) => setF({ ...f, tasks: e.target.value })} data-testid="v3-tasks-input" />
        </Field>
      </div>
      <p className="text-xs text-slate-400">Les alertes sont créées dans « Suivis & maintenance ». Aucun e-mail n'est envoyé au client et aucun contrat n'est renouvelé sans votre validation.</p>
      <Button onClick={save} className="dt-glow" data-testid="v3-settings-save-button">Enregistrer</Button>
    </section>
  );
};
